import { _get } from 'frontcore/utils/communications/apiClient'
import { PerimeterAPIClient, PerimeterAPIResponse } from 'frontcore/presentation/perimeter-finder/domain/types'
import { URL_BASE_PERIMETERS } from 'frontcore/presentation/perimeter-finder/constants'

export default class PerimeterHttpAPI implements PerimeterAPIClient {
  async request (): Promise<PerimeterAPIResponse[]> {
    const url = `${URL_BASE_PERIMETERS}/?format=info`
    const perimeter = await _get(url)
    return perimeter as PerimeterAPIResponse[]
  }

  async retrieve (id: number): Promise<PerimeterAPIResponse> {
    const url = `${URL_BASE_PERIMETERS}/${id}/`
    const perimeter = await _get(url)
    return perimeter as PerimeterAPIResponse
  }
}
